import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const toggleLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className="flex items-center gap-0.5 bg-gray-100 rounded-full px-1 py-1">
      <button
        onClick={() => toggleLanguage('ja')}
        className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
          currentLang === 'ja'
            ? 'bg-[#255485] text-white'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        JP
      </button>
      <button
        onClick={() => toggleLanguage('en')}
        className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
          currentLang === 'en'
            ? 'bg-[#255485] text-white'
            : 'text-gray-500 hover:text-gray-700'
        }`}
      >
        EN
      </button>
    </div>
  );
}
